import { ServiceItem } from '../../types';
import { isFlatRateService } from '../../services/flatRateLogic';
import { contractedQuantity } from '../../services/nepPosition';
import { istLeistungVomTyp, ServiceTileType } from '../../services/serviceTypeMatch';

/** Berechnet Ist-/Soll-Mengen einer Leistungsart (Begehung, Vorankündigung, ...) aus der Leistungsliste.
 *
 * Welche Positionen zu einer Kachel gehoeren, entscheidet istLeistungVomTyp —
 * dort steht auch, warum 'einweisung' und 'asplan' keinen Textarm haben.
 *
 * Das Soll einer NEP-Position ist, was gebucht wurde (contractedQuantity):
 * eine unbestellte Eventualmenge darf keine Kachel auf „3 von 8" setzen.
 *
 * Eine Monatspauschale gehoert nie in die Begehungsmenge, auch wenn ihr Titel
 * „Begehung" traegt oder ihre LV-Nummer unter 2.7./2.8. steht: ihre Mengen
 * sind MONATE. Mitgezaehlt stuende „12 Monate" im Begehungskontingent, und
 * jeder gebuchte Monat hob den Begehungsstand, gegen den der Projektcheck das
 * Archiv haelt. Nachweiszeilen auf der Pauschale rechnet der Aufrufer ueber
 * inspectionProofCount (projectLv) hinzu — diese Funktion sieht kein Protokoll. */
export const calculateStats = (services: ServiceItem[], type: ServiceTileType) => {
    const rel = services.filter(s => istLeistungVomTyp(s, type) && !(type === 'inspection' && isFlatRateService(s)));
    if (!rel.length) return null;
    return { used: rel.reduce((a, s) => a + (s.quantityUsed || 0), 0), contracted: rel.reduce((a, s) => a + contractedQuantity(s), 0) };
};
